export const sponsor_info = [
  {
    company: "Bloomberg",
    tier: "more",
    logo: "bloomberg.png",
  },

  // {
  //   company: "Palantir",
  //   tier: "gold",
  //   logo: "palantir.png",
  // },
  {
    company: "Old Mission",
    tier: "more",
    logo: "old_mission.png",
  },
  // {
  //   company: "Roblox",
  //   tier: "silver",
  //   logo: "roblox.png",
  // },
  {
    company: "Jane Street",
    tier: "more",
    logo: "jane_street.png",
  },
  {
    company: "Sixth Street",
    tier: "more",
    logo: "sixth_street.png",
  },
  {
    company: "Visa",
    tier: "more",
    logo: "visa.png",
  },
  {
    company: "HRT",
    tier: "more",
    logo: "hrt.png",
  }
];